import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { callAPI } from './apiActions';
import settlementSubscriptionService from '../../services/subscriptions/settlementSubscriptionService';
export var FETCHING_ACCOUNT_SETTLEMENT_POSITIONS = 'FETCHING_ACCOUNT_SETTLEMENT_POSITIONS';
export var FETCH_ACCOUNT_SETTLEMENT_POSITIONS_ERROR = 'FETCH_ACCOUNT_SETTLEMENT_POSITIONS_ERROR';
export var fetchingAccountSettlementPositions = {
  type: FETCHING_ACCOUNT_SETTLEMENT_POSITIONS
};
export var RECEIVE_ACCOUNT_SETTLEMENT_POSITIONS = 'RECEIVE_ACCOUNT_SETTLEMENT_POSITIONS';
export var fetchAccountSettlementPositionsError = function fetchAccountSettlementPositionsError(payload) {
  return {
    type: FETCH_ACCOUNT_SETTLEMENT_POSITIONS_ERROR,
    payload: payload
  };
};
export var subscribeToAccountSettlements = function subscribeToAccountSettlements() {
  return function (dispatch) {
    settlementSubscriptionService.subscribe(function (updates) {
      dispatch(receiveAccountSettlementPositions(updates));
    });
  };
};
export var receiveAccountSettlementPositions = function receiveAccountSettlementPositions(payload) {
  return {
    type: RECEIVE_ACCOUNT_SETTLEMENT_POSITIONS,
    payload: payload
  };
};
export var getAccountSettlementPositions = function getAccountSettlementPositions() {
  var AccountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var payload, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(fetchingAccountSettlementPositions);
              payload = {
                OMSId: getState().user.userInfo.OMSId,
                AccountId: AccountId
              };
              _context.next = 4;
              return dispatch(callAPI('GetAccountSettlementPositions', payload));
            case 4:
              data = _context.sent;
              if (!data) {
                _context.next = 7;
                break;
              }
              return _context.abrupt('return', dispatch(receiveAccountSettlementPositions(data)));
            case 7:
              return _context.abrupt('return', dispatch(fetchAccountSettlementPositionsError(data.errormsg)));
            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    return function (_x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
};